<!-- Mobile top navbar -->
<mat-toolbar color="primary" class="mobile-toolbar" *ngIf="isMobile">
  <button mat-icon-button (click)="toggleMobileMenu()">
    <mat-icon>menu</mat-icon>
  </button>
  <span class="toolbar-title">Perse ConsentWallet</span>
</mat-toolbar>

<mat-sidenav-container class="dashboard-container" [class.mobile-view]="isMobile">
  <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'"
               [opened]="!isMobile"
               class="sidebar">
    <mat-nav-list>
      <!-- Dashboard route -->
      <mat-list-item routerLink="/dashboard" routerLinkActive="active" (click)="isMobile && sidenav.close()">
        <mat-icon matListItemIcon>home</mat-icon>
        <div matListItemTitle>Dashboard</div>
      </mat-list-item>
      
      <!-- Meter Details route -->
      <mat-list-item routerLink="/meter-details" routerLinkActive="active" (click)="isMobile && sidenav.close()">
        <mat-icon matListItemIcon>location_city</mat-icon>
        <div matListItemTitle>My Consents</div>
      </mat-list-item>


    </mat-nav-list>
    
    <div class="sidebar-footer">
      <mat-nav-list>
        <mat-list-item routerLink="/about" routerLinkActive="active" (click)="isMobile && sidenav.close()">
          <mat-icon matListItemIcon>info</mat-icon>
          <div matListItemTitle>About</div>
        </mat-list-item>
        <mat-list-item routerLink="/profile" routerLinkActive="active" (click)="isMobile && sidenav.close()">
          <mat-icon matListItemIcon>person</mat-icon>
          <div matListItemTitle>Profile</div>
        </mat-list-item>
        <!-- <mat-list-item (click)="onDeleteAccount(); isMobile && sidenav.close()">
          <mat-icon matListItemIcon>delete_forever</mat-icon>
          <div matListItemTitle>Delete Account</div>
        </mat-list-item> -->
        <mat-list-item (click)="onLogout(); isMobile && sidenav.close()">
          <mat-icon matListItemIcon>exit_to_app</mat-icon>
          <div matListItemTitle>Logout</div>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </mat-sidenav>

  <!-- Main content -->
  <mat-sidenav-content class="main-content">
    <!-- Verification Warning Banner -->
    <mat-card *ngIf="shouldShowVerificationWarning" class="verification-warning-banner">
      <mat-card-content>
        <div class="warning-content">
          <mat-icon class="warning-icon icon-no-shrink">warning</mat-icon>
          <span class="warning-text">
            The account is pending manual verification. Data download will be enabled post verification.
          </span>
        </div>
      </mat-card-content>
    </mat-card>
    
    <!-- This is where child pages inside the layout will appear -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
